import React from "react";
import useStepPersistence from "../../Hooks/useStepPersistience";
import Occupations from "../../organisms/Occupations";
const OccupationsContainer = ({ formData, setFormStep, user, errors, loading, setPreviousStep, }) => {
    const [data, handleChange, handleSubmit] = useStepPersistence({
        has_repossessions: null,
        has_preferential_claim: null,
        repossessions_count: undefined,
        first_debt_collector_name: "",
        reference: "",
        debt_collector_postal_code: "",
        debt_collector_house_number: "",
        debt_collector_street_suffix: "",
        debt_collector_street: "",
        debt_collector_city: "",
        has_withholding_healthcare_institute: null,
        withholding_healthcare_institute: undefined,
        has_own_settlement: null,
        own_settlement_balance: undefined,
        own_settlement_amount: undefined,
        own_settlement_frequency: "",
        periodically_payment: undefined,
        total_claim: undefined,
    }, formData, setFormStep);
    return (React.createElement(Occupations, { setPreviousStep: setPreviousStep, onSubmit: handleSubmit, onChange: handleChange, data: Object.assign(Object.assign({}, formData), data), user: user, errors: errors, loading: loading }));
};
export default OccupationsContainer;
